import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <header className="bg-navy px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-75" data-mp="eiv62y7sfcld">
      <h1 className="text-[1.35rem] font-extrabold uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-76" data-mp="9k0ep7vr8fpn">
        The Complete Visual Study System for{' '}
        <span className="text-electric" data-id="element-77" data-mp="4jm5vnmbx1qk">Neurology Students</span>
      </h1>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-white/85 sm:text-base" data-id="element-78" data-mp="128yy08bm5nwj">
        Stop jumping between textbooks, lecture notes, anatomy diagrams and
        scattered references every time you need to understand a neurological
        concept. Use organized visual maps, pathway diagrams, comparison
        charts, clinical patterns and reasoning tools to understand what
        you're studying and connect the information logically.
      </p>
      <p className="mt-1 font-heading text-xs font-extrabold uppercase leading-tight tracking-wide text-gold sm:text-sm" data-id="element-79" data-mp="3825y4q50c7ld">
        Visualize. Connect. Understand with confidence.
      </p>

      <BoxImage className="mx-auto mt-2 max-w-[270px] sm:max-w-[340px]" data-id="element-80" data-mp="3o85a17s6zv2z" />

      <div className="mx-auto mt-2 max-w-md" data-id="element-81" data-mp="39acxmohxzmt0">
        <CTAButton label="🧠 YES! I WANT THE COMPLETE SYSTEM" data-id="element-82" data-mp="399bcfr77pjxk" />
        <p className="mt-1.5 font-heading text-xs font-extrabold uppercase tracking-widest text-white" data-id="element-83" data-mp="3e95ztkrs3rdv">
          GET NEUROLOGY VISUAL ATLAS™ TODAY
        </p>
        <p className="mt-1 text-[0.65rem] font-bold uppercase tracking-wide text-white/75 sm:text-xs" data-id="element-84" data-mp="30gq6jbooj7q5">
          🛡️ 7-Day Money-Back Guarantee <span className="text-gold" data-id="element-85" data-mp="2qk3lalsfyenl">•</span> ⚡
          COMPLETE 6-IN-1 SYSTEM
        </p>
      </div>
    </header>;
}